
import { 
    DELETE_ORGANIZATION,
    DELETE_ORGANIZATION_SUCCESS,
    DELETE_ORGANIZATION_FAIL, 
    DELETE_ORGANIZATION_RESET,
} from "../actions/deleteOrganizationAction";

const initialState = {
    apiState: "",
    message: "",
    data: null,
    error: "",
}

const deleteOrganizationReducer = (state = initialState, action) => {
    switch (action.type) {
        case DELETE_ORGANIZATION:
            return {
                ...state,
                apiState: "loading",
            };
        case DELETE_ORGANIZATION_SUCCESS:
            return {
                ...state,
                apiState: "success",
                data: action.response.data,
                message: action.response.message ? action.response.message : "success",
            };
        case DELETE_ORGANIZATION_FAIL:
            return {
                ...state,
                apiState: "error",
                error: action.response.errors,
                message: action.response.message ? action.response.message : "error",
            };
        case DELETE_ORGANIZATION_RESET:
            return initialState;
        default: 
            return state;
    }
};

export default deleteOrganizationReducer;
